var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.agreement.title))]),_c('div',{staticClass:"contenn",staticStyle:{"font-size":"14px"},domProps:{"innerHTML":_vm._s(_vm.agreement.content)}}),_c('div',{staticClass:"cancel",on:{"click":_vm.goBack}},[_vm._v("返回")])])
}
var staticRenderFns = []

export { render, staticRenderFns }